import React from 'react';
import { useQuery, gql } from '@apollo/client';
import { Spinner } from 'equasion-lib';
import ApiError from '@/lib/shared-coms/ApiError';
import PlaceholderPurchaseOrders from './PlaceholderPurchaseOrders';
import { useRootStore } from '@/lib/providers/RootProvider';

const PLACEHOLDER_PURCHASE_ORDERS = gql`
  query placeholderPurchaseOrders($clientId: ID!) {
    placeholderPurchaseOrders(clientId: $clientId) {
      id
      clientPurchaseOrderNumber
      clientStatus
      vendor {
        id
        companyName
      }
    }
  }
`;

const PlaceholderPurchaseOrdersData = (props) => {
  const clientId = useRootStore((state) => state.selectedCompany.id);

  const { data, error, loading } = useQuery(PLACEHOLDER_PURCHASE_ORDERS, {
    fetchPolicy: 'network-only',
    variables: { clientId },
  });

  if (loading) return <Spinner />;
  if (error) return <ApiError error={error} />;

  const { placeholderPurchaseOrders } = data || {};

  return (
    <PlaceholderPurchaseOrders
      purchaseOrders={placeholderPurchaseOrders}
      clientId={clientId}
      {...props}
    />
  );
};

export default PlaceholderPurchaseOrdersData;
